import React, { Component, Fragment } from "react";
import { compose } from "redux";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Snackbar,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { withStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { withRouter } from "react-router";
import moment from "moment-timezone";
import OfferDetails from "../OfferDetails";
import { Form, Formik } from "formik";
import OfferForm from "../OfferForm";
import { info } from "core/Offers/validations";
import { Translation, withTranslation } from "react-i18next";
import { TARGET_PREFIXES } from "common/constants";

class SuperadminOfferReview extends Component {
  state = {
    dialog: null,
    snackbar: null,
    editing: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const prevOfferStatus = prevProps.offer.status;
    const latestOfferStatus = this.props.offer.status;
    const prevTimestamp = prevProps.offer.updated_at;
    const latestTimestamp = this.props.offer.updated_at;

    if (
      prevOfferStatus !== latestOfferStatus ||
      !moment(prevTimestamp).isSame(latestTimestamp)
    ) {
      // this._showSnackbar(alreadyApproved ? 'updated' : latestOfferStatus);
      this._showSnackbar("updated");
    }
  }

  _showSnackbar(status) {
    const { t } = this.props;
    if (status === "approved") {
      this.setState({ snackbar: "Offer has been approved" });
    } else if (status === "updated") {
      this.setState({ snackbar: t("offer_view.offer_update_success") });
    } else {
      this.setState({ snackbar: "Changes have been requested" });
    }
  }

  _openDialog = (dialog) => {
    this.setState({ dialog });
  };

  _closeDialog = () => {
    this.setState({ dialog: null });
  };

  _handleApproveConfirm = () => {
    this._closeDialog();
    this.props.handleApprove();
  };

  _handleChangeRequestConfirm = () => {
    this._closeDialog();
    const { target } = this.state.values;
    const values = { ...this.state.values };

    if (
      typeof target === "string" &&
      target.startsWith(TARGET_PREFIXES.group)
    ) {
      values.target = "group";
      values.event_id = null;
      values.building_group_id = parseInt(
        target.slice(TARGET_PREFIXES.group.length),
        10,
      );
    } else if (target !== "community" && target !== "building") {
      values.event_id = target;
      values.target = "event";
      values.building_group_id = null;
    } else {
      values.event_id = null;
      values.building_group_id = null;
    }
    this.props.handleChangeRequest(values);
    this.setEditing(false);
  };

  _handleDeleteConfirm = () => {
    this._closeDialog();
    this.props.handleDelete();
  };

  handleDeleteRequest = () => {
    this._openDialog("delete");
  };

  _handleSnackbarClose = () => {
    this.setState({ snackbar: null });
  };

  setEditing = (editing) => {
    this.setState({ editing });
  };

  handleSubmit = (values, form) => {
    this.setState({ values, form }, () => {
      // if (offer.status === 'approved') {
      this._openDialog("update");
      // } else {
      //   this._openDialog('changeRequest');
      // }
    });
  };

  renderDialog = ({ title, content, onConfirm }) => {
    return (
      <Dialog open onClose={this._closeDialog}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this._closeDialog}>Cancel</Button>
          <Button autoFocus onClick={onConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderSnackbar = () => {
    const { snackbar } = this.state;

    if (!snackbar) {
      return null;
    }

    return (
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={!!snackbar}
        autoHideDuration={4000}
        onClose={this._handleSnackbarClose}
        message={<span>{snackbar}</span>}
      />
    );
  };

  render() {
    const {
      offer,
      timezone,
      template,
      classes,
      history,
      downloadRedemptions,
    } = this.props;
    const { dialog, editing } = this.state;

    const initialValues = {
      ...offer,
      offer_template: template,
      legal: offer.legal || template.legal,
      defaultTerms: !offer.legal,
      start_at: moment(offer.start_at).tz(timezone),
      end_at: moment(offer.end_at).tz(timezone),
      quantity: offer.quantity || "",
      target:
        offer.target === "group" && offer.building_group_id
          ? `${TARGET_PREFIXES.group}${offer.building_group_id}`
          : offer.event_id
            ? offer.event_id
            : offer.target,
    };

    return (
      <Translation>
        {(t) => (
          <Fragment>
            <Grid container direction="row">
              <Grid size={{ xs: 12 }}>
                <Grid container direction="row" alignItems="center">
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="h5">{offer.name}</Typography>
                  </Grid>
                  {/* <Grid size={{ xs: 4 }}>
                    <OfferStatus status={offer.status} variant='body2' />
                  </Grid> */}
                </Grid>
              </Grid>
              {editing ? (
                <Formik
                  initialValues={initialValues}
                  enableReinitialize={false}
                  validationSchema={info(t)}
                  onSubmit={this.handleSubmit}
                >
                  {(formikProps) => (
                    <Grid size={{ xs: 12 }}>
                      <Form onSubmit={formikProps.handleSubmit}>
                        <Grid container direction="row">
                          <Grid size={{ xs: 12 }}>
                            <OfferForm
                              {...formikProps}
                              eventTargets={this.props.eventTargets}
                              groupTargets={this.props.groupTargets}
                              timezone={timezone}
                            />
                          </Grid>
                          <Grid size={{ xs: 6 }} className={classes.buttonRow}>
                            <Grid
                              container
                              direction="row"
                              justifyContent="flex-end"
                            >
                              <Grid className={classes.cancelWrapper}>
                                <Button onClick={() => history.goBack()}>
                                  {t("offer_view.back_btn")}
                                </Button>
                              </Grid>
                              <Button
                                onClick={() => this.setEditing(false)}
                                className={classes.button}
                              >
                                {t("offer_view.cancel_btn")}
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                type="submit"
                                className={classes.button}
                              >
                                {/* {isApproved ? 'Update' : 'Request Changes'} */}
                                {t("offer_view.update_btn")}
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Form>
                    </Grid>
                  )}
                </Formik>
              ) : (
                <Fragment>
                  <Grid size={{ xs: 12 }}>
                    <OfferDetails
                      values={offer}
                      timezone={timezone}
                      template={template}
                      downloadRedemptions={downloadRedemptions}
                      eventTargets={this.props.eventTargets}
                      groupTargets={this.props.groupTargets}
                    />
                  </Grid>
                  <Grid size={{ xs: 6 }} className={classes.buttonRow}>
                    <Grid container direction="row" justifyContent="flex-end">
                      <Grid className={classes.cancelWrapper}>
                        <Button onClick={() => history.goBack()}>
                          {t("offer_view.back_btn")}
                        </Button>
                      </Grid>
                      <Fragment>
                        {offer.status === "submitted" ? (
                          <Button
                            color="secondary"
                            onClick={this.handleDeleteRequest}
                            className={classes.button}
                          >
                            <DeleteIcon />
                            {t("offer_view.delete_btn")}
                          </Button>
                        ) : null}
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => this.setEditing(true)}
                          className={classes.button}
                        >
                          {t("offer_view.edit_btn")}
                        </Button>
                        {/* {offer.status === "approved" ? null : (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this._openDialog("approve")}
                            className={classes.button}
                            disabled={editing}
                          >
                            Approve
                          </Button>
                        )} */}
                      </Fragment>
                    </Grid>
                  </Grid>
                </Fragment>
              )}
            </Grid>

            {dialog === "approve" &&
              this.renderDialog({
                title: "Confirm offer approval",
                content:
                  "Are you sure you want to approve and publish this offer?",
                onConfirm: this._handleApproveConfirm,
              })}

            {dialog === "changeRequest" &&
              this.renderDialog({
                title: "Confirm change request",
                content: "Are you sure you want to submit this change request?",
                onConfirm: this._handleChangeRequestConfirm,
              })}

            {dialog === "update" &&
              this.renderDialog({
                title: "Confirm update",
                content: "Are you sure you want to update it?",
                //'This offer has been approved already. Are you sure you want to update it?',
                onConfirm: this._handleChangeRequestConfirm,
              })}

            {dialog === "delete" &&
              this.renderDialog({
                title: "Confirm offer deletion",
                content:
                  "Click 'Confirm' to permanently remove this offer from the system. This action cannot be undone.",
                onConfirm: this._handleDeleteConfirm,
              })}

            {this.renderSnackbar()}
          </Fragment>
        )}
      </Translation>
    );
  }
}

SuperadminOfferReview.propTypes = {
  offer: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired,
  template: PropTypes.object.isRequired,
  handleApprove: PropTypes.func.isRequired,
  handleChangeRequest: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  downloadRedemptions: PropTypes.func.isRequired,
  eventTargets: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  groupTargets: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const styles = (theme) => ({
  buttonRow: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  cancelWrapper: {
    flexGrow: 2,
  },
});

const enhanced = compose(withStyles(styles), withRouter, withTranslation());

export default enhanced(SuperadminOfferReview);
